<template>
  <div :class="['slide-section', wrapperClasses]">
    <h5 :class="['content-link', toggleTextClasses, shouldOpen ? 'open' : 'closed']"
        @click="$emit('onToggleTextClick')"
        :data-cy="`${dataCy}-toggle`">
      {{toggleText}}
    </h5>
    <div :class="['slide-section__slider', sliderClasses, shouldOpen ? 'slide-down' : 'slide-up']">
      <slot name="mainContent"></slot>
      <slot name="extraContent"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      shouldOpen: Boolean,
      showToggleText: Boolean,
      sliderClasses: String,
      toggleText: String,
      toggleTextClasses: String,
      wrapperClasses: String
    },

    name: 'ToggleSectionSlide',

    computed: {
      dataCy(){
        return this.toggleText.replace(' ','-')
      }
    }
  }
</script>
